import {Col, Row} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Back from "../layout/template/back";
import DataTable from 'react-data-table-component';
import {Link} from 'react-router-dom';
import AppRoute from "../../utils/AppRoute";
import ApiService from "../../services/ApiService";
import DateTimeUtils from "../../services/DateTimeUtils";

const AdminCoupons = () => {

    const [currentRow, setCurrentRow] = useState();
    const pageSize = 100000;
    const [couponData, setCouponData] = useState([])

    useEffect(() => {
        let couponList = []
        ApiService.getAllCoupons(pageSize).then(coupons => {
            coupons.couponDtos.forEach(coupon => {
                couponList.push(
                    {
                        code: coupon.code,
                        id: coupon.id,
                        basketId: coupon.basketId,
                        datefrom: DateTimeUtils.formatCourseStartData(coupon.validUntil).toLocaleString(),
                        validUntil: DateTimeUtils.formatCourseStartData(coupon.validUntil).toLocaleString(),
                        dateused: coupon.dateOfUse? DateTimeUtils.formatCourseStartData(coupon.dateOfUse) : "",
                        status: coupon.status,
                        value: coupon.discount === 0? `${coupon.cost} CHF` : `${coupon.discount}%`
                    }
                )
            })


            setCouponData(couponList);
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const columns = [
        {
            name: 'Codice buono',
            selector: row => row.code,
            sortable: true,
        },
        {
            name: 'Data emissione',
            selector: row => row.datefrom,
            sortable: true,
        },
        {
            name: 'Data scadenza',
            selector: row => row.validUntil,
            sortable: true,
        },
        {
            name: 'Data utilizzo',
            selector: row => row.dateused,
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
        },
        {
            name: 'Importo',
            selector: row => row.value,
            sortable: true,
        },
        {
            cell: (row) => <div className={'d-flex gap-2'}>
                {row.basketId !== null ?<Link className={'btn btn-sm btn-outline-primary text-nowrap'}
                       state={{from: (currentRow && currentRow.basketId)}} to={AppRoute.ADMIN_DETAIL_ORDERS}>Link
                    ordine</Link> : ""}
                <Link className={'btn btn-sm btn-primary text-nowrap'} to={AppRoute.ADMIN_DETAIL_COUPON}
              state={{from: (currentRow && currentRow.id)}}>Dettaglio</Link></div>,
            right: true,
        },
    ];

    return (
        <>
            <Row>
                <Col xs={12}>
                    <Row>
                        <Col>
                            <Back/>
                        </Col>
                    </Row>
                    <Row className={'justify-content-between'}>
                        <Col>
                            <div className={'title-page-section mt-5 mb-5'}>
                                <h2 className={'title'}>Coupons</h2>
                            </div>
                        </Col>

                        <Col xs={'auto'}>
                            <div className={'mt-5'}>
                                <Link to={AppRoute.ADMIN_EDIT_COUPON} className={'btn btn-primary fw-bold mb-3 px-4'}>Nuovo
                                    coupon</Link>
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col xs={12}>
                    <DataTable
                        columns={columns}
                        data={couponData}
                        highlightOnHover
                        pagination
                        responsive
                        striped
                        paginationPerPage={25}
                        paginationRowsPerPageOptions={[25, 50, 100]}
                        onRowMouseEnter={(row) => setCurrentRow(row)}
                    />
                </Col>
            </Row>
        </>

    );
}

export default AdminCoupons;